import React, { useMemo, memo, useCallback } from "react"
import BootstrapTable from 'react-bootstrap-table-next'
import { useTranslation } from 'react-i18next'
import UniversalTableWrapperTest from '../../Table/UniversalTableWrapperTest'
import TableProvider, { useTableState } from '../../Table/TableProvider'
const ReasonsTableInner = ({
    position,
    handleChangePositionByKey
}) => {
    const { t } = useTranslation()
    const { tableRef } = useTableState()
    const selectedReturnReasons = position.selectedReturnReasons
    const handleCheckedBox = useCallback(id => {
        var newValues = [...selectedReturnReasons]
        let foundIndex = newValues.findIndex(e => e.id === id);
        if (foundIndex > -1) {
            newValues[foundIndex].isSelected = !newValues[foundIndex].isSelected
        }
        handleChangePositionByKey(position.id, "selectedReturnReasons", newValues)
    }, [selectedReturnReasons, position.id, handleChangePositionByKey])
    const disabled = position.metaProperties && position.metaProperties.find(metaProp => (metaProp.pointer === '/selectedReturnReasons' && metaProp.attributes === 'isReadOnly'))
    const columns = useMemo(() => ([
        {
            dataField: 'isSelected',
            text: "",
            sort: false,
            headerAttrs: {
                hidden: true
            },
            formatter: (cell, row, rowIndex, extraProps) => (
                <span>
                    <input type="checkbox" id={row.id} name="scales"
                        checked={cell} onChange={() => { }} disabled={disabled}>
                    </input>
                </span>
            ), formatExtraData: {
                handleCheckedBox
            }
        },
        {
            dataField: 'displayName',
            text: t('complaints:returnReasons'),
            sort: true,
            headerAttrs: {
                hidden: true
            },
        },
    ]), [handleCheckedBox, t, disabled])
    const onRowClick = (cell, row, rowIndex) => {
        handleCheckedBox(row.id)
    }

    return (
        <>
            <div className="spacing-down">
                <UniversalTableWrapperTest  >
                    <BootstrapTable
                        ref={tableRef}
                        noDataIndication={() => <div className="no-data-placeholder">{t('returnsProcessingPage:noReturnReasons')}</div>}
                        bootstrap4
                        keyField="id"
                        hover
                        data={selectedReturnReasons}
                        columns={columns}
                        bordered={false}
                        rowEvents={disabled ? null : { onClick: onRowClick }}
                        disabled={disabled}
                    />
                </UniversalTableWrapperTest>
            </div>
        </>
    )
}
const ReasonsTable = memo(({ ...rest }) => {
    return (
        <TableProvider >
            <ReasonsTableInner  {...rest} />
        </TableProvider>
    )
})
export default ReasonsTable
